export const faultRulesInitialValues = {
  code: "",
  name: "",
  description: "",
  priority_status: "",
};
